import { useEffect, useState } from 'react';
import { FieldProps } from 'formik';
import SVG from 'Components/SVG';
import { SVG_TYPE } from 'Shared/enums';

interface InputProps {
  label: string;
  name: string;
  type: string;

  placeholder?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  value?: string;
  secondValue?: string;
  multi?: boolean;
  treshold?: number;
  removable?: boolean;
  maxLength?: number;
  id?: string;
  inputMode?: string;
  pattern?: string;
  variant?: string;

  //formik
  field: any;
  errors: any;
  form: any;
  touched?: any;
  onChange?: (value) => void;
  handleOnChange?: any;
  isOnBlurAction: boolean;
  editUser: (data) => void;
  onFocus: any;
  onBlur?: any;
}

function Input({
  label,
  className = '',
  name,
  placeholder,
  required,
  multi,
  type,
  form,
  errors = {},
  field,
  onChange,
  treshold = 500,
  removable,
  maxLength,
  id,
  inputMode,
  pattern,
  variant,
}: InputProps & FieldProps) {
  const [inputFirstPart, setInputFirstPart] = useState<string>(field?.value?.inputFirstPart);
  const [inputSecondPart, setInputSecondPart] = useState<string>(field?.value?.inputSecondPart);
  const [value, setValue] = useState<string>(field?.value);
  const [debouncedValues, setDebouncedValues] = useState<string>(field?.value);
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = variant === 'password';

  const handleFirstPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = {
      inputFirstPart: e.target.value,
      inputSecondPart,
    };
    form.setFieldValue(field.name, value);
    setInputFirstPart(e.target.value);
  };
  const handleSecondPartChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = {
      inputFirstPart,
      inputSecondPart: e.target.value,
    };
    form.setFieldValue(field.name, value);
    setInputSecondPart(e.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValues(value);
    }, treshold);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [value]);

  useEffect(() => {
    setValue(field.value);
  }, [field.value]);

  useEffect(() => {
    if (debouncedValues) {
      form.setFieldValue(field.name, value);
    }
    onChange && onChange(debouncedValues);
  }, [debouncedValues]);

  function preventNonNumericalInput(e) {
    e = e || window.event;
    const tempValue = field.value + '';
    const charCode = typeof e.which == 'undefined' ? e.keyCode : e.which;
    const charStr = String.fromCharCode(charCode);
    const isDotFirst = field.value === '' && charStr === '.';
    const isMoreThanOneDot = tempValue?.includes('.') && charStr === '.';
    const isComma = charStr === ',';
    const isUserSelecting = document.getSelection().toString() !== '';
    const isZeroAndNotDot = field.value === '0' && charStr !== '.';
    const isMoreThanTwoDigitsAfterDot = tempValue?.includes('.') && tempValue.split('.')[1].length >= 2 && !isUserSelecting;
    const validation = !charStr.match(/^[0-9./]+$/) || isDotFirst || isMoreThanOneDot || isComma || isZeroAndNotDot || isMoreThanTwoDigitsAfterDot;
    if (validation) e.preventDefault();
    if (field.value === '0' && charStr.match(/^[0-9./]+$/)) {
      form.setFieldValue(field.name, charStr);
    }
  }

  return (
    <div id={id} className={`input__wrapper ${className} ${form.touched[field.name] && errors[field.name] ? 'input__wrapper--error' : ''}`}>
      <label className="input__label" htmlFor={field.name}>
        {label} {required ? null : <p className="input__optional">(opcjonalne)</p>}
      </label>
      {multi ? (
        <div className="input__double-input">
          <input
            {...field}
            name={field.name}
            className="input"
            value={inputFirstPart}
            onChange={(e) => handleFirstPartChange(e)}
            id={name}
            type={type}
          />
          <input {...field} name={field.name} className="input" value={inputSecondPart} onChange={(e) => handleSecondPartChange(e)} type={type} />
        </div>
      ) : (
        <>
          <input
            {...field}
            name={field.name}
            className={`input ${removable ? 'input--removable' : ''}`}
            value={value}
            onChange={(e) => {
              form.setFieldValue(field.name, e.target.value);
              setValue(e.target.value);
            }}
            id={name}
            placeholder={placeholder}
            inputMode={inputMode}
            type={isPassword ? (showPassword ? 'text' : 'password') : type === 'number' ? 'text' : type}
            pattern={pattern}
            maxLength={maxLength}
            onKeyPress={(e) => type === 'number' && preventNonNumericalInput(e)}
          />
          {removable ? (
            <span className="input__removable" onClick={() => form.setFieldValue(field.name, '')}>
              <SVG type={field.value ? SVG_TYPE.CLOSE : SVG_TYPE.SEARCH} />
            </span>
          ) : null}
          {isPassword ? (
            <span className="change-password-modal__icon" onClick={() => setShowPassword(!showPassword)}>
              <SVG type={showPassword ? SVG_TYPE.EYE : SVG_TYPE.EYE_OFF} />
            </span>
          ) : null}
        </>
      )}
      {errors && form.touched && <div className="input__error">{form.touched[field.name] && <span>{errors[field.name]}</span>}</div>}
    </div>
  );
}

export default Input;
